var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4859 10.2642C14.5993 9.7721 14.6603 9.27054 14.6603 8.76847C14.6603 6.43872 13.474 4.31722 11.4868 3.09381C11.3656 3.01952 11.2083 3.05718 11.1343 3.17757C11.06 3.29822 11.0977 3.45576 11.2181 3.53005C13.0527 4.6597 14.148 6.61777 14.148 8.76847C14.148 9.2106 14.0968 9.65247 14.0012 10.0869C13.8831 10.0623 13.7609 10.0493 13.6357 10.0493C12.6469 10.0493 11.8426 10.8538 11.8426 11.8424C11.8426 12.8309 12.6469 13.6355 13.6357 13.6355C14.6245 13.6355 15.4288 12.8309 15.4288 11.8424C15.4288 11.1612 15.0469 10.5677 14.4859 10.2642ZM13.6357 13.1231C12.9295 13.1231 12.3549 12.5486 12.3549 11.8424C12.3549 11.1361 12.9295 10.5616 13.6357 10.5616C14.3419 10.5616 14.9165 11.1361 14.9165 11.8424C14.9165 12.5486 14.3419 13.1231 13.6357 13.1231Z",
    fill: "url(#paint0_linear_987_22970)",
    stroke: "url(#paint1_linear_987_22970)",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3492 14.4506C9.60251 14.7595 8.81226 14.9162 7.99998 14.9162C6.36442 14.9162 4.7911 14.2566 3.64095 13.0996C3.96012 12.7755 4.15762 12.3319 4.15762 11.8424C4.15762 10.8538 3.35328 10.0493 2.36451 10.0493C1.37575 10.0493 0.571411 10.8538 0.571411 11.8424C0.571411 12.8309 1.37575 13.6355 2.36451 13.6355C2.67856 13.6355 2.97366 13.5537 3.23058 13.4113C4.48038 14.6949 6.20534 15.4286 7.99998 15.4286C8.87988 15.4286 9.73622 15.2587 10.5452 14.9237C10.6758 14.8696 10.7381 14.7198 10.684 14.5889C10.63 14.4585 10.4798 14.3965 10.3492 14.4506ZM1.08373 11.8424C1.08373 11.1361 1.65829 10.5616 2.36451 10.5616C3.07074 10.5616 3.6453 11.1361 3.6453 11.8424C3.6453 12.5486 3.07074 13.1231 2.36451 13.1231C1.65829 13.1231 1.08373 12.5486 1.08373 11.8424Z",
    fill: "url(#paint2_linear_987_22970)",
    stroke: "url(#paint3_linear_987_22970)",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59614 8.56688C1.60229 8.5674 1.60844 8.56765 1.61433 8.56765C1.74779 8.56765 1.85998 8.46468 1.86972 8.32942C2.0521 5.74505 3.81293 3.58539 6.28075 2.86968C6.49951 3.61305 7.18678 4.15764 8.00008 4.15764C8.98885 4.15764 9.79318 3.35305 9.79318 2.36454C9.79318 1.37603 8.98885 0.571434 8.00008 0.571434C7.01362 0.571434 6.21082 1.37244 6.20723 2.35813C3.49683 3.11303 1.55797 5.46917 1.35868 8.29356C1.34869 8.43445 1.455 8.55715 1.59614 8.56688ZM8.00008 1.08375C8.70631 1.08375 9.28087 1.65831 9.28087 2.36454C9.28087 3.07076 8.70631 3.64533 8.00008 3.64533C7.29385 3.64533 6.71929 3.07076 6.71929 2.36454C6.71929 1.65831 7.29385 1.08375 8.00008 1.08375Z",
    fill: "url(#paint4_linear_987_22970)",
    stroke: "url(#paint5_linear_987_22970)",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_987_22970",
    x1: 11.0962,
    y1: 8.34558,
    x2: 15.4288,
    y2: 8.34558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_987_22970",
    x1: 11.0962,
    y1: 8.34558,
    x2: 15.4288,
    y2: 8.34558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_987_22970",
    x1: 0.571411,
    y1: 12.7389,
    x2: 10.7035,
    y2: 12.7389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_987_22970",
    x1: 0.571411,
    y1: 12.7389,
    x2: 10.7035,
    y2: 12.7389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_987_22970",
    x1: 1.35803,
    y1: 4.56954,
    x2: 9.79318,
    y2: 4.56954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_987_22970",
    x1: 1.35803,
    y1: 4.56954,
    x2: 9.79318,
    y2: 4.56954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.7082d18446d4cf60f70a83799d9ef634.svg";
export { ForwardRef as ReactComponent };